export const variantBAssets = {
  penseLogo: "/media/public-acquisition/variant-b/pense-logo.png",
  associatedLogo: "/media/public-acquisition/variant-b/associated-logo.png",
  heroIllustration: "/media/public-acquisition/variant-b/hero-illustration.png",
  providerAviva: "/media/public-acquisition/variant-b/provider-aviva.png",
  providerCanadaLife: "/media/public-acquisition/variant-b/provider-canada-life.png",
  providerJust: "/media/public-acquisition/variant-b/provider-just.png",
  providerLegalGeneral: "/media/public-acquisition/variant-b/provider-legal-general.png",
  providerLv: "/media/public-acquisition/variant-b/provider-lv.png",
  providerPrudential: "/media/public-acquisition/variant-b/provider-prudential.png",
  providerScottishWidows: "/media/public-acquisition/variant-b/provider-scottish-widows.png",
  providerStandardLife: "/media/public-acquisition/variant-b/provider-standard-life.png",
  processFeedback: "/media/public-acquisition/variant-b/process-feedback.png",
  onlineSchool: "/media/illustrations/BW/PNG/online-school-1.png",
  onlineSchoolLoader: "/media/illustrations/BW/GIF/online-school-dots-tea-loader.gif",
  processProfit: "/media/public-acquisition/variant-b/process-profit.png",
  processSchool: "/media/public-acquisition/variant-b/process-school.png",
  processRelax: "/media/public-acquisition/variant-b/process-relax.png",
  fscsProtected: "/media/public-acquisition/variant-b/fscs-protected.png",
  talkIllustration: "/media/public-acquisition/variant-b/talk-illustration.png",
  pressDailyMail: "/media/public-acquisition/variant-b/press-daily-mail.png",
  pressMetro: "/media/public-acquisition/variant-b/press-metro.png",
  pressMailFinance: "/media/public-acquisition/variant-b/press-mail-finance.png",
  pressTheSun: "/media/public-acquisition/variant-b/press-the-sun.png",
  pressRadio: "/media/public-acquisition/variant-b/press-radio.png",
  pressTheI: "/media/press/thei.jpg",
  pressTheTelegraph: "/media/press/thetelegraph.png",
  pressThisIsMoney: "/media/press/thisismoney_logo.png",
  pressTheTimes: "/media/press/the-times-logo_dark.png",
  reviewStars: "/media/public-acquisition/variant-b/review-stars-landing.png",
  reviewAvatar: "/media/public-acquisition/variant-b/review-avatar-landing.png",
  advisorSmall1: "/media/public-acquisition/variant-b/advisor-small-1.png",
  advisorSmall2: "/media/public-acquisition/variant-b/advisor-small-2.png",
  advisorSmall3: "/media/public-acquisition/variant-b/advisor-small-3.png",
} as const;

export const variantBProviders = [
  ["Standard Life", variantBAssets.providerStandardLife],
  ["Scottish Widows", variantBAssets.providerScottishWidows],
  ["Aviva", variantBAssets.providerAviva],
  ["Just", variantBAssets.providerJust],
  ["Canada Life", variantBAssets.providerCanadaLife],
  ["Prudential", variantBAssets.providerPrudential],
  ["LV", variantBAssets.providerLv],
  ["Legal & General", variantBAssets.providerLegalGeneral],
] as const;

export const variantBPressLogos = [
  ["Daily Mail", variantBAssets.pressDailyMail],
  ["Metro", variantBAssets.pressMetro],
  ["Mail Finance", variantBAssets.pressMailFinance],
  ["The Sun", variantBAssets.pressTheSun],
  ["Radio Money", variantBAssets.pressRadio],
  ["The i", variantBAssets.pressTheI],
  ["The Telegraph", variantBAssets.pressTheTelegraph],
  ["This is Money", variantBAssets.pressThisIsMoney],
  ["The Times", variantBAssets.pressTheTimes]
] as const;
